module.exports = __webpack_public_path__ + "static/media/bolt.d4d66c25.svg";